export default "__VITE_ASSET__Cch7uV1M__"